import { useState } from "react";

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = () => {
    const value = email.trim();
    if (!value || !value.includes("@")) {
      setMessage("填一个常用邮箱，就能收到每天的吃瓜速递");
      return;
    }
    setMessage(`已记录 ${value}，演示订阅，仅供围观`);
    setEmail("");
  };

  return (
    <section id="subscribe" className="bg-background-100 py-14 md:py-24">
      <div className="px-4 md:px-10 max-w-4xl mx-auto">
        <div className="rounded-lg bg-background-50 border border-background-200 px-6 py-10 md:px-12 md:py-14 text-center">
          <span className="inline-flex items-center gap-2 text-primary-600 text-xs md:text-sm tracking-[0.2em] uppercase">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line"></i>
            </span>
            吃瓜速递
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            每天一封热帖速览
          </h2>
          <p className="mt-4 max-w-lg mx-auto text-sm md:text-base text-foreground-600 leading-relaxed">
            当天飙升最快的火爆帖、最出圈的热评，整理成一封短报，省得你一条条翻。
          </p>

          <div className="mt-8 max-w-lg mx-auto flex flex-col sm:flex-row gap-2 sm:gap-0 sm:rounded-md sm:overflow-hidden sm:border sm:border-background-300">
            <div className="flex-1 flex items-center gap-2 bg-background-50 rounded-md sm:rounded-none px-4 h-12 border border-background-300 sm:border-0">
              <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-mail-line text-base"></i>
              </span>
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") handleSubscribe();
                }}
                placeholder="你的邮箱地址"
                className="flex-1 h-full bg-transparent outline-none border-0 text-sm text-foreground-900 placeholder:text-foreground-400"
              />
            </div>
            <button
              type="button"
              onClick={handleSubscribe}
              className="h-12 px-7 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md sm:rounded-none cursor-pointer transition-colors"
            >
              订阅速递
            </button>
          </div>

          {message && <p className="mt-3 text-xs md:text-sm text-primary-600">{message}</p>}

          <p className="mt-4 text-xs text-foreground-500">
            随时可退订，内容仅为网络话题聚合，理性吃瓜。
          </p>
        </div>
      </div>
    </section>
  );
}